import { TrendingDown, TrendingUp, Minus } from "lucide-react";
import { cn } from "@/lib/utils/cn";

export function DeltaPill({ deltaPct }: { deltaPct: number | null }) {
  if (deltaPct === null || deltaPct === undefined) {
    return (
      <span className="inline-flex items-center gap-0.5 text-2xs font-semibold px-1.5 py-0.5 rounded bg-bg-subtle text-fg-muted">
        <Minus size={10} />—
      </span>
    );
  }
  const trend = deltaPct > 0.5 ? "up" : deltaPct < -0.5 ? "down" : "flat";
  const Icon = trend === "up" ? TrendingUp : trend === "down" ? TrendingDown : Minus;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-0.5 text-2xs font-semibold px-1.5 py-0.5 rounded tabular-nums",
        trend === "up" && "bg-success-soft text-success",
        trend === "down" && "bg-danger-soft text-danger",
        trend === "flat" && "bg-bg-subtle text-fg-muted",
      )}
    >
      <Icon size={10} />
      {Math.abs(Math.round(deltaPct))}%
    </span>
  );
}
